import {
  Button,
  Panel,
  PanelActions,
  PanelDescription,
  PanelHeader,
  PanelTitle,
} from '@customerio/pluma-components/react';
import { STARTUP_APPLICATION_URL, STARTUP_PROGRAM_URL } from '@/constants/startup-program';

type StartupPlanInfoProps = {
  /** Fires the `pricing_card_button_clicked` analytics when either button is clicked. */
  onTrackClick: () => void;
};

/**
 * The startup-program panel shown beneath the plan grid when the account has no active subscription.
 * Both buttons fire the `onboarding/pricing_card_button_clicked` analytics.
 */
export function StartupPlanInfo({ onTrackClick }: StartupPlanInfoProps) {
  return (
    <Panel style={{ gridColumn: 'span 3' }}>
      <PanelHeader>
        <PanelTitle text="product-h3">Launch &amp; grow with Customer.io's Startup Program</PanelTitle>
        <PanelDescription>Get best-in-class marketing automation tools at a fraction of the price.</PanelDescription>
        <PanelActions>
          <Button href={STARTUP_PROGRAM_URL} isExternal={true} onClick={onTrackClick}>
            Learn more
          </Button>
          <Button href={STARTUP_APPLICATION_URL} isExternal={true} onClick={onTrackClick}>
            Apply now
          </Button>
        </PanelActions>
      </PanelHeader>
    </Panel>
  );
}
